<template>
    <div class="form-group" :class="'form-field-' + nameDashed" :id="$_id" v-bind="rowAttrs" v-show="isVisible()">
        <div :class="$_inputHolderClasses">
            <slot name="input" :scope="_self">
                <oc-field
                    v-model="model"
                    v-on="inputListeners"
                    :id="$_inputId"
                    :placeholder="placeholderText"
                    :name="name"
                    v-bind="$_processedInputAttrs"
                    :readonly="isLoading || isReadonly()"
                    :disabled="isDisabled()"
                    v-class="$_inputClasses"
                    ref="input"
                >
                    <template slot="view" slot-scope="viewAttrs">
                        <slot name="view" v-bind="viewAttrs"></slot>
                    </template>
                </oc-field>
            </slot>

            <slot name="label" :scope="_self" v-if="displayLabel">
                <oc-label-input
                    v-if="labelText !== null"
                    v-text="labelText"
                    :for="$_inputId"
                    v-bind="labelAttrs"
                    v-class="$_labelClasses"
                />

                <sup class="required-asterisk" v-if="isRequired()">*</sup>

                <slot v-if="helpUseIcon" name="help" :scope="_self">
                    <oc-icon
                        type="question-circle"
                        v-if="help !== null"
                        :title="help"
                        v-bind="helpAttrs"
                        class="form-field-help form-field-help-question text-muted"
                    />
                </slot>
            </slot>
        </div>

        <slot name="feedback" v-bind="feedbackAttrs">
            <oc-form-feedback
                v-if="displayFeedback"
                v-bind="feedbackAttrs"
                v-class="feedback.class"
                ref="feedback"
            />
        </slot>

        <slot v-if="! helpUseIcon" name="help" :scope="_self">
            <p
                v-if="help !== null"
                class="form-field-help form-text text-muted"
                v-text="help"
                v-bind="helpAttrs"
            />
        </slot>
    </div>
</template>

<script>
export default {
    computed: {
        $_mode() {
            return this.$attrs.$mode
        },
        $_inputHolderClasses() {
            return this.$_mode === 'view' ? 'form-check' : 'custom-control custom-checkbox'
        },
        $_labelClasses() {
            return [
                [this.labelClasses],
                {
                    'form-check-label': this.$_mode === 'view',
                    'custom-control-label': this.$_mode !== 'view'
                }
            ]
        },
        $_processedInputAttrs() {
            let attrs = this.processedInputAttrs

            if( attrs.style === undefined ) {
                attrs.style = {}
            }

            if( this.$_mode === 'view' ) {
                attrs.style.marginTop = 0
            }

            return attrs
        },
        $_inputClasses() {
            return [
                [this.inputClasses],
                {
                    'form-check-input': this.$_mode === 'view',
                    'custom-control-input': this.$_mode !== 'view'
                }
            ]
        }
    }
}
</script>
